// Color mapping for chips/buttons across the CV detail view.
// Extracted out of ResultCVInformation to flatten nested ternaries
// and keep the parent component's cognitive complexity manageable.

type ChipColor = 'success' | 'error' | 'warning' | 'info' | 'default'

// mailerStatusColor maps email send status to a chip color.
export const mailerStatusColor = (status: string): ChipColor => {
    if (status === 'sent') return 'success'
    if (status === 'failed') return 'error'
    return 'default'
}

// screenResultColor maps the HR screen result (PASS/FAIL/...) to a chip color.
export const screenResultColor = (value: string | undefined): ChipColor => {
    if (value === 'PASS') return 'success'
    if (value === 'FAIL') return 'error'
    return 'default'
}

// finalStatusColor maps the interview final status to a chip color.
export const finalStatusColor = (status: string | undefined): ChipColor => {
    if (status === 'Interview') return 'info'
    if (status === 'Pass Interview') return 'success'
    if (status === 'Fail Interview') return 'error'
    return 'default'
}
